import { getZtCoreVersion } from './libs'
import { trace } from 'app-core/lib/trace'
const parseJSON = (str) => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return {}
  }
}
export const appPrefetchInterceptor = (config) => {
  if (config.prefetch && window.flutter_inappwebview && getZtCoreVersion() >= 6) {
    console.log('执行预加载', config.url)
    trace.tag('APP_PREFETCH', {
      url: config.url,
      prefetch: true
    })
    let isSuccess = false
    return Promise.race([
      new Promise((resolve) => {
        setTimeout(() => {
          if (!isSuccess) {
            console.log('flutter无响应，200ms后继续请求')
            resolve(config)
          }
        }, 200)
      }),
      new Promise((resolve) => {
        window.flutter_inappwebview
          .callHandler(
            'requestPrefetch',
            JSON.stringify({
              path: config.url,
              duration: 3
            })
          )
          .then((res) => {
            trace.tag('APP_PREFETCH_SUCCESS', {
              url: config.url,
              res
            })
            console.log('flutter预加载结果：', res)
            // app响应状态码为0, 预加载成功
            if (res.code == 0) {
              // 预加载成功
              const data = parseJSON(res.data)
              if (data.code == '0') {
                isSuccess = true
                // 直接返回预加载结果，不发送实际请求
                config.adapter = () => {
                  console.log('fffff返回预加载结果', data)
                  return Promise.resolve({
                    data,
                    status: 200,
                    statusText: 'OK',
                    headers: {},
                    config
                  })
                }
                resolve(config)
              }
            } else {
              resolve(config)
            }
          })
          .catch((error) => {
            trace.tag('APP_PREFETCH_ERROR', {
              url: config.url,
              error: error
            })
            isSuccess = true
            console.log('flutter预加载失败')
            resolve(config)
          })
      })
    ])
      .then(() => {
        return Promise.resolve(config)
      })
      .catch(() => {
        return Promise.resolve(config)
      })
  }
  return Promise.resolve(config)
}
